import classNames from 'classnames'
import { MouseEvent, PropsWithChildren, forwardRef, useRef } from 'react'

import { Scrollbar } from '@ui/v2/Scrollbar/Scrollbar'

import styles from './PopoverList.module.scss'

export interface PopoverListProps {
  variant?: 'default' | 'compact'
  onMouseOver?: (event: MouseEvent<HTMLDivElement, globalThis.MouseEvent>) => void
}

export const PopoverList = forwardRef<HTMLDivElement, PropsWithChildren<PopoverListProps>>(
  (props, forwardedRef) => {
    const { variant = 'default', children, onMouseOver } = props
    const localRef = useRef<HTMLDivElement | null>(null)

    // keep Scrollbar working off the same node, whether or not a ref was forwarded
    const setRefs = (node: HTMLDivElement | null) => {
      localRef.current = node
      if (typeof forwardedRef === 'function') {
        forwardedRef(node)
      } else if (forwardedRef) {
        forwardedRef.current = node
      }
    }

    return (
      <>
        <div
          ref={setRefs}
          className={classNames(styles.dropdownList, 'custom-scrollbar-y-active', {
            [styles.compact]: variant === 'compact',
          })}
          onMouseOver={onMouseOver}
        >
          {children}
        </div>
        <Scrollbar parentRef={localRef} orientation='vertical' size='sm' />
      </>
    )
  }
)

PopoverList.displayName = 'PopoverList'
